import React from "react";
import GetInitials from "../GetInitials";
import { isEmpty } from "lodash";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import WarningModal from "../WarningModal/WarningModal";
import { useLocation } from "react-router-dom";
import { faCheckCircle, faTimesCircle } from "@fortawesome/pro-light-svg-icons";
import {
  FLOW_TYPES,
  getPathWithParam,
  OPTIONS_DATA_MAPPER,
  ROUTES,
  ssnMasking,
  usDateFormat,
} from "../../utils";
import AddToolTip from "../AddToolTip";

const WithDrawalApprovalCard = ({ employeeWithDrawal, onClickOfCard }) => {
  const location = useLocation();
  var withdrawalType = employeeWithDrawal.withdrawalType.split(".");
  var withdrawalTypeLength = withdrawalType.length - 1;
  var withdrawalTypeAnswer = withdrawalType[withdrawalTypeLength];
  return (
    <div className="withDrawalApprovalCard">
      <div
        className="d-flex"
        style={{ justifyContent: "center", alignItems: "center" }}
        onClick={() => {
          onClickOfCard();
        }}
      >
        <div className="employee-icon-wrapper ">
          {!isEmpty(employeeWithDrawal.imageURL) ? (
            <img
              alt=""
              src={employeeWithDrawal.imageURL}
              style={{ width: "96px", height: "96px", borderRadius: "50%" }}
              className="img-fluid"
            />
          ) : (
            <div style={{ marginTop: "10%", marginLeft: "50px" }}>
              <GetInitials name={employeeWithDrawal.employeeName} />
            </div>
          )}
        </div>

        <div style={{ flexDirection: "column", marginBottom: "30px" }}>
          <div
            className="approvalEmployeeName"
            style={{
              fontWeight: "500",
              fontSize: "14px",
              lineHeight: "21px",
              marginLeft: "60px",
            }}
          >
            {employeeWithDrawal.employeeName.length > 10 ? (
              <AddToolTip name={employeeWithDrawal.employeeName}>
                {employeeWithDrawal.employeeName.slice(0, 10)}...
              </AddToolTip>
            ) : (
              <>{employeeWithDrawal.employeeName}</>
            )}
          </div>
          <div
            className="ssn"
            style={{ marginLeft: "60px", whiteSpace: "nowrap" }}
          >
            {ssnMasking(employeeWithDrawal.uniquePersonalIdentification)}
          </div>
          {/* <div className="employeeStatus">
            <FontAwesomeIcon
              icon={faCheckCircle}
              className="employeeStatusIcon"
              style={{ marginLeft: "60px", whiteSpace: "nowrap" }}
            />
            {employeeWithDrawal.employeeStatus}
          </div> */}

          {employeeWithDrawal.employeeStatus == "Active" ? (
            <div className="employeeStatusActive">
              <FontAwesomeIcon
                icon={faCheckCircle}
                className="employeeStatusActiveIcon"
                style={{ marginLeft: "60px", whiteSpace: "nowrap" }}
              />
              {employeeWithDrawal.employeeStatus}
            </div>
          ) : (
            <div className="employeeStatusTerminated">
              <FontAwesomeIcon
                icon={faTimesCircle}
                className="employeeStatusTerminatedIcon"
                style={{ marginLeft: "60px", whiteSpace: "nowrap" }}
              />
              {employeeWithDrawal.employeeStatus}
            </div>
          )}
        </div>

        {/* vertical Line */}
        <div
          style={{
            height: "70px",
            borderRight: "1px solid #BDBDBD",
            marginBottom: "5px",
            marginLeft: "60px",
          }}
        ></div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "76px",
            whiteSpace: "nowrap",
            fontStyle: "normal",
            fontWeight: "400",
            fontSize: "14px",
            color: "#777777",
            flex: "none",
            order: "0",
            flexGrow: "0",
            marginBottom: "60px",
          }}
        >
          <div
            style={{
              marginRight: "50%",
              whiteSpace: "nowrap",
              marginTop: "60%",
              lineHeight: "30px",
              marginLeft: "70px",
            }}
          >
            {"Plan Name"}
            <div className="planName-ans">
              {employeeWithDrawal.planName.length > 10 ? (
                <AddToolTip name={employeeWithDrawal.planName}>
                  {employeeWithDrawal.planName.slice(0, 16)}...
                </AddToolTip>
              ) : (
                <>{employeeWithDrawal.planName}</>
              )}
            </div>
          </div>

          <div
            style={{
              marginRight: "50%",
              whiteSpace: "nowrap",
              marginTop: "60%",
              lineHeight: "30px",
            }}
          >
            Request type
            <div className="planName-ans">
              {withdrawalTypeAnswer.length > 8 ? (
                <AddToolTip name={withdrawalTypeAnswer}>
                  {withdrawalTypeAnswer.slice(0, 12)}...
                </AddToolTip>
              ) : (
                <div>{withdrawalTypeAnswer}</div>
              )}
              {/* {withdrawalTypeAnswer.length < 10 ? <div>{withdrawalTypeAnswer}</div> : 
              <AddToolTip name={withdrawalTypeAnswer}>
                {withdrawalTypeAnswer.slice(0,)}...
              </AddToolTip>} */}
            </div>
          </div>
          <div
            style={{
              whiteSpace: "nowrap",
              marginTop: "60%",
              lineHeight: "30px",
              marginRight: "50%",
              marginLeft: "10px",
            }}
          >
            {"Requested date"}
            <div className="planName-ans" style={{ marginRight: "50%" }}>
              {usDateFormat(employeeWithDrawal.requestDate)}
            </div>
          </div>
        </div>

        {/* 
    <FontAwesomeIcon
       icon={faTrashAlt}
       size="13px"
       color="#FF0000"
       onClick = {()=><WarningModal/>}
    /> */}
      </div>
    </div>
  );
};

export default WithDrawalApprovalCard;
